import { z } from "zod";
import { AddressModelSchema } from "./AddressModel";

export enum Gender {
  Male = "Male",
  Female = "Female",
  UnDisclosed = "UnDisclosed",
}

export const CreditCheckDetailsModelSchema = z.object({
  status: z.string().nullable(),
  isCompanyDirector: z.boolean().nullable(),
  readRepresentativeRequirements: z.boolean().nullable(),
  legalName: z.string().nullable(),
  gender: z.nativeEnum(Gender).nullable(),
  dateOfBirth: z.coerce.date().nullable(),
  driversLicenseNumber: z.string().nullable(),
  driversLicenseVersionNo: z.string().nullable(),
  agreedToCreditCheck: z.boolean().nullable(),
  agreedToPersonalGuarantee: z.boolean().nullable(),
  personalGuaranteeEmail: z.string().nullable(),
  personalGuaranteeObtainedByEmailOrPost: z.boolean().nullable(),
  personalGuaranteeFileLocation: z.string().nullable(),
  creditCheckPassed: z.boolean().nullable(),
  creditCheckSufficientInfo: z.boolean().nullable(),
  legalNameComplete: z.boolean().nullable(),
  dateOfBirthComplete: z.boolean().nullable(),
  driversLicenseComplete: z.boolean().nullable(),
  residentialAddressComplete: z.boolean().nullable(),
  sectionComplete: z.boolean().nullable(),
  residentialAddress: AddressModelSchema.nullable(),
  residentialAddressText: z.string().nullable(),
  hasManualResidentialAddress: z.boolean().nullable(),
});
